import { render, staticRenderFns } from "./SnapshotSelectionGalleryNew.vue?vue&type=template&id=2d96b940&scoped=true"
import script from "./SnapshotSelectionGalleryNew.vue?vue&type=script&lang=js"
export * from "./SnapshotSelectionGalleryNew.vue?vue&type=script&lang=js"
import style0 from "./SnapshotSelectionGalleryNew.vue?vue&type=style&index=0&id=2d96b940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96b940",
  null
  
)

export default component.exports